import React, { Component } from "react";
import { Button, Confirm, Form, Header, Message, Modal, Segment, Loader, Icon } from "semantic-ui-react";

import { AppContext } from "../../utils/context";
import request from "../../utils/request";

const resetState = (props) => {
  return {
    isLoading: false,
    drawId: 0,
    finalDraw: 0,
    isSecondary: 0,
    prices: [],
    drawSelected: null,
    tickets: [],
    winningTicket: false,
    timeRangeStart: null,
    timeRangeEnd: null,
    selectedPrize: null,
    xhrStatus: null,
    xhrMessage: null,
    devicesInUseWarning: null,
    pickWinnerModal: false,
    void: false,
    final: false,
    confirmShopify: false,
    drawDisabled: false,
    isCtaJackpot: false,
    openDrawStatusModal: false
  }
}

class PickWinner extends Component {
    constructor(props) {
        super(props);
        this.state = resetState(props);
    }

    handleToggle = (e, { name, value }) => this.setState({ [name]: this.state[name] === 1 ? 0 : 1 });

    setPreCheck = opt => {
        this.setState({
            xhrStatus: null,
            xhrMessage: null
        });

        let hasActive = false;

        for (var i in this.props.devices['data']) { // Check if any devices still active if not secondary draw
            if (!opt.issecondary) {
                let device = this.props.devices['data'][i];
                if ((device['unit_id'] !== 0 && device['unit_id'] !== '-' || device['can_deactivate'] == false) && device['confirm'] === 0) {
                    hasActive = true;
                }
            }
        }

        this.setState({
            drawDisabled: hasActive ? true: false,
            devicesInUseWarning: hasActive ? 'Please ensure all devices are deactivated before performing Jackpot draw.': null
        });
        return;
    };

    openFinalDraw = () => this.setState({ final: true });

    closeFinalDraw = () => this.setState({ final: false });

    confirmFinalDraw = (e) => this.setState({ final: false }, this.handleToggle(e, { name: 'finalDraw', value: 1 }));

    openVoid = () => this.setState({ void: true });

    closeVoid = () => this.setState({ void: false });

    confirmVoid = () => {
        if (this.props.event.shopify_enabled) {
            this.setState({ void: false, confirmShopify: true });
        } else {
            this.setState({ void: false, pickWinnerModal: true }, () => this.props.init());
        }
    }

    closeShopifyModal = () => this.setState({ confirmShopify: false }); // close shopify sales confirm modal

    confirmShopifyModal = () => this.setState({ confirmShopify: false, pickWinnerModal: true }, () => this.props.init());

    handleChange = (e, { name, value }) => {
        let { prizeOptions } = this.props;
        if (name === 'drawSelected' && prizeOptions && value) {
            prizeOptions.map(opt => {
            if (opt.id === value) {
                this.setState({ selectedPrize: value, selectedPrizeTitle: opt.text });

                if (opt.criteria) {
                    this.setState({
                        timeRangeStart: opt.criteria.start,
                        timeRangeEnd: opt.criteria.end
                    });
                }

                if (opt.issecondary) {
                    this.setState({ isSecondary: 1, devicesInUseWarning: null, drawDisabled: false, isCtaJackpot: false });
                } else {
                    this.setState({ isSecondary: 0, isCtaJackpot: true });
                    this.setPreCheck(opt); // check for active devices
                }
            }
            });
        }

        this.setState({ [name]: value });
    }

    handleBEPDraw = () => { // bep draw logic
        const { eventId } = this.props;
        if (!this.state.winningTicket) return;
        this.setState({ isLoading: true, drawDisabled: true });
        let payload = {
            number: this.state.winningTicket,
            draw_id: this.state.selectedPrize
        };
        request.post(this, `api:/event/${eventId}/winners/save`, payload).then(resp => {
        this.setState({
            xhrStatus: resp.success ? "success" : "error",
            xhrMessage: resp.message,
            isLoading: false
        }, () => this.handleReset(resp));
        });
    };

    handleRNGDraw = () => { // rng draw logic
        const { event, eventId } = this.props;
        this.setState({
            isLoading: true,
            drawDisabled: true,
            openDrawStatusModal: event.is_import_raffle > 0 ? true : false
        });
        let payload = {
            draw_id: this.state.selectedPrize,
            final_draw: this.state.finalDraw
        };
        return request.post(this, `api:/event/${eventId}/winners/draw`, payload).then(resp => {
            this.setState({
                xhrStatus: resp.success ? "success" : "error",
                xhrMessage: event.is_import_raffle < 1 ? resp.message: null,
                isLoading: false
            }, () => this.handleReset(resp));
        });
    };

    handleReset = (resp = false) => { // reset pick winner modal on close
        if (resp === "close") {
            this.setState({
                drawId: 0,
                drawSelected: null,
                winningTicket: false,
                selectedPrize: null,
                drawDisabled: false,
                xhrStatus: null,
                xhrMessage: null
            });
        }
        if (!resp.exception && !resp.errors && resp.success) {
            this.setState({ isLoading: false, drawDisabled: true });
            this.props.init();
        } else {
            this.setState({
                xhrStatus: resp.success ? "success" : "error",
                xhrMessage: resp.message,
                isloading: false,
                drawDisabled: false
            });
        }
    };

    closeModal = () => {
        this.setState({ pickWinnerModal: false }, () => this.handleReset("close"));
    }

    closeDrawStatusModal = () => {
        this.setState({ openDrawStatusModal: false }, () => this.props.fetchPrizes());
    }

    render() {
        const {
            isLoading,
            finalDraw,
            winningTicket,
            xhrStatus,
            xhrMessage,
            isSecondary,
            devicesInUseWarning,
            drawDisabled,
            drawSelected
        } = this.state;
        const { event, warningMsg, disableRNGPickWinnerBtn, disableBEPPickWinnerBtn, parentLoading, winners, ctaCardType } = this.props;
        const { backend_type } = this.context.config;
        const { language, settings } = this.context;
        let { prizeOptions } = this.props

        const latestDraw = winners.filter(winner => winner.drawId === this.state.selectedPrize);
        let latestDrawStatus = "in progress";
        if (latestDraw && latestDraw[0]) {
            if (latestDraw[0].status == "new" || latestDraw[0].status == "in_progress" || latestDraw[0].status == "queued")
                latestDrawStatus = "in progress";
            else latestDrawStatus = latestDraw[0].status;
        }

        let disableRNGDraw = false; // rng pick winner btn flag
        let disableBEPDraw = false; // bep pick winner btn flag

        // check for conditions to determine rng pick winner btn to be disabled or not
        if (!drawSelected || drawDisabled || winningTicket || disableRNGPickWinnerBtn) {
            disableRNGDraw = true;
        }
        // check for conditions to determine bep pick winner btn to be disabled or not
        if (!drawSelected || drawDisabled || !winningTicket || disableBEPPickWinnerBtn) {
            disableBEPDraw = true;
        }

        return (
        <>
            <Confirm
                open={this.state.void}
                content='Please confirm that all devices are deactivated, and all voids/refunds have been processed, before selecting a Jackpot winner'
                confirmButton='Confirm'
                onCancel={this.closeVoid}
                onConfirm={this.confirmVoid}
            />

            <Confirm
                open={this.state.confirmShopify}
                content={() => (
                    <Segment basic>
                    <Header as="h3">Prior to proceeding with this draw have you confirmed the following?</Header>
                    <p>1. All returned tickets have been voided.</p>
                    <p>2. You have ensured that Shopify and dashboard online sales match.</p>
                    </Segment>
                )}
                confirmButton='Confirm'
                onCancel={this.closeShopifyModal}
                onConfirm={this.confirmShopifyModal}
            />

            {event.game_id === 3 && +settings.hidden.allow_must_go_draw > 0 &&
                <Confirm
                    open={this.state.final}
                    content={() => (
                        <Segment basic>
                        <h4>Are you sure you make this the final draw?</h4>
                        <p>If a <strong>{language.en[`game_${event.game_id}_prize_title`]}</strong> has not yet been selected, a <strong>{language.en[`game_${event.game_id}_prize_title`]}</strong> winner will be selected immediately.</p>
                        <p>If the <strong>{language.en[`game_${event.game_id}_prize_title`]}</strong> winner's chosen envelope does not contain the winning card,
                            a <strong>{language.en[`game_${event.game_id}_final_draw`]}</strong> draw will be held, see rules provided for more details.</p>
                        <p>The <strong>{language.en[`game_${event.game_id}_final_draw`]}</strong> may take a while and cannot be undone.</p>
                        </Segment>
                    )}
                    confirmButton="Yes, I'm sure"
                    onCancel={this.closeFinalDraw}
                    onConfirm={this.confirmFinalDraw}
                />
            }

            {event.game_id === 3 && +settings.hidden.allow_must_go_draw === 0 &&
                <Modal
                    open={this.state.final}
                    size={"mini"}
                    content={() => (
                        <Segment basic>
                        <h4>Final Draws have been disabled</h4>
                        <br />
                        <p>If you require a final draw, please contact <a href="mailto:cgsupport@cbnco.com">support</a></p>
                        <br />
                        <hr />
                        <Button primary content="Okay" onClick={this.closeFinalDraw} floated="right" />
                        <br /><br />
                        </Segment>
                    )}
                    onConfirm={this.closeFinalDraw}
                    onCancel={this.closeFinalDraw}
                />
            }

            {event.is_import_raffle > 0 && this.state.openDrawStatusModal &&
                <Modal
                    open={this.state.openDrawStatusModal}
                    size={"small"}
                    content={() => (
                        <Segment basic>
                        {latestDrawStatus === "in progress" && <h4>Winner selection in progress, please stay on this dialog to view results.</h4>}
                        {latestDrawStatus === "complete" && <h4>Winner selection complete, this dialog can be closed.</h4>}
                        {latestDrawStatus === "error" && <h4>Winner selection error, please try again.</h4>}
                        <br />
                        <p>Draw Title: <b>{this.state.selectedPrizeTitle}</b></p>
                        <br />
                        <>Draw Status:
                            <b> {latestDrawStatus} </b>
                            {latestDrawStatus === "in progress" &&
                                <Loader active className='workaround' size='mini' inline />}
                            {latestDrawStatus === "complete" &&
                                <Icon name="check circle" color="green" />}
                            {latestDrawStatus === "error" &&
                                <Icon name="window close" color="red" />}
                        </>
                        <br />
                        <hr />
                        <Button primary content="Okay" onClick={() => this.closeDrawStatusModal()} floated="right" />
                        <br /><br />
                        </Segment>
                    )}
                />
            }

            <Modal
                trigger={<Button primary loading={parentLoading} disabled={parentLoading} onClick={this.openVoid}>Pick a Winner</Button>}
                closeIcon
                open={this.state.pickWinnerModal}
                onClose={() => this.closeModal(this.props)}
                size="small"
            >
                <Header icon='trophy' content='Pick a Winner' />
                <Modal.Content>
                    <Form
                        id="pickWinner"
                        loading={isLoading}
                        success={xhrStatus === "success"}
                        error={xhrStatus === "error"}
                        warning={warningMsg !== "" || devicesInUseWarning !== null}
                    >
                        <Message success content={xhrMessage} />
                        <Message warning content={warningMsg || devicesInUseWarning} />
                        <Message error content={xhrMessage} />
                        <Form.Select
                            name="drawSelected"
                            label="Draw(s)"
                            placeholder="Select a Draw"
                            search
                            options={prizeOptions}
                            value={this.state.drawSelected}
                            onChange={this.handleChange}
                        />
                        {ctaCardType !== "physical" && event.game_id === 3 && this.state.isCtaJackpot &&
                            <Form.Group>
                                <Form.Checkbox
                                    warning={"true"}
                                    name={"finalDraw"}
                                    label="This is the final draw. Tickets will be selected until the winning card is found, or all the purchased envelopes have been revealed."
                                    value={1}
                                    checked={finalDraw === 1}
                                    onChange={finalDraw === 1 ? this.handleToggle : this.openFinalDraw}
                                />
                            </Form.Group>
                        }

                        {+isSecondary > 0 &&
                            <div>
                                <b>{'Draw Criteria: '}</b>
                                {(this.state.timeRangeStart || this.state.timeRangeEnd) ?
                                <span>{`Between ${this.state.timeRangeStart || ""} and ${this.state.timeRangeEnd || ""}`}</span> :
                                <span>None</span>}
                            </div>
                        }

                        {backend_type === "bep" &&
                            <Form.Group widths="equal">
                                <Form.Input
                                    name="winningTicket"
                                    fluid
                                    size="large"
                                    label="Winning Ticket"
                                    placeholder="Winning Ticket"
                                    value={winningTicket ? winningTicket.number : null}
                                    onChange={this.handleChange}
                                />
                                {event?.game_id === 3 && (
                                    <Form.Field>
                                        <label>Card</label>
                                        {winningTicket &&
                                            <Header style={{ marginTop: "0px" }}>
                                            {winningTicket.card_suit === "D" ? (<span style={{ "color": "red" }}>&diams;</span>) : ""}
                                            {winningTicket.card_suit === "H" ? (<span style={{ "color": "red" }}>&hearts;</span>) : ""}
                                            {winningTicket.card_suit === "S" ? (<span>&spades;</span>) : ""}
                                            {winningTicket.card_suit === "C" ? (<span>&clubs;</span>) : ""}
                                            {" "}
                                            {winningTicket.card_rank}
                                            {winningTicket.card_suit === "D" ? (<span> of diamonds</span>) : ""}
                                            {winningTicket.card_suit === "H" ? (<span> of hearts</span>) : ""}
                                            {winningTicket.card_suit === "S" ? (<span> of spades</span>) : ""}
                                            {winningTicket.card_suit === "C" ? (<span> of clubs</span>) : ""}
                                            <Header.Subheader>found in Envelope #{winningTicket.envelope}</Header.Subheader>
                                            </Header>
                                        }
                                    </Form.Field>
                                )}
                            </Form.Group>
                        }
                    </Form>
                </Modal.Content>
                <Modal.Actions>
                    {backend_type === "rng" ? (
                        <Button primary content="Select Random Ticket" onClick={this.handleRNGDraw} disabled={disableRNGDraw} />
                    ) : (
                        <Button primary content="Save Winner" onClick={this.handleBEPDraw} disabled={disableBEPDraw} />
                    )}
                </Modal.Actions>
            </Modal>
        </>
        );
    }
}

PickWinner.contextType = AppContext;

export default PickWinner;
